import * as Yup from "yup";
import { validationErrors, fieldLengths } from "./validationRules.js";
import validationUtils from "./ValidationUtils.js";

const registerOrgSchema = Yup.object().shape({
  name: validationUtils?.validateName("organization_name"),

  email: validationUtils?.validateEmail(),

  password: validationUtils?.validatePassword(),

  password_confirm: Yup.string()
    .required(validationErrors?.getRequiredField("confirm password"))
    .test(
      "passwords-match",
      validationErrors?.password?.notMatch,
      function (value) {
        return !value || this?.parent?.password === value;
      }
    ),

  phone_number: validationUtils?.validateUnrequiredPhoneNumber("phone_number"),

  license_number: Yup.string()
    .trim()
    .max(
      fieldLengths?.license_number?.max,
      validationErrors?.getMaxLength(
        "License number",
        fieldLengths?.license_number?.max
      )
    ),

  address: validationUtils?.validateUnRequiredAddress("address"),

  state: validationUtils?.validateUnRequiredAddress("state"),

  city: validationUtils?.validateUnRequiredAddress("city"),

  zipcode: validationUtils?.validateUnRequiredAddress("zipcode"),
});

export default registerOrgSchema;
